<template>
  <v-menu
    :close-on-content-click="false"
    v-model="menuOpened"
    :nudge-width="450"
    max-width="600"
    transition="scale-transition"
  >
    <template v-slot:activator="{ on }">
      <v-btn icon
             v-on="on"
             @click.stop.prevent=""
      >
        <v-icon>{{ icon }}</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-text class="text--primary">
        <div v-if="loadingDetalhes">
          <px-circular-loading/>
        </div>
        <template v-if="!loadingDetalhes && detalhes">
          <v-row dense>
            <v-col cols="10">
              <div class="title font-weight-bold">
                {{ detalhes.nome || fornecedor.pessoa.nome }}
              </div>
            </v-col>
            <v-col cols="2">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" class="ml-3" icon link target="_blank" :to="linkFornecedor">
                    <v-icon>mdi-open-in-new</v-icon>
                  </v-btn>
                </template>
                <span v-if="this.isCadastrado">Editar</span>
                <span v-else>Cadastrar</span>
              </v-tooltip>
            </v-col>
          </v-row>
          <div v-if="showScore && score">
            <v-skeleton-loader
              :loading="loading"
              max-width="150"
              type="text">
              <px-show-avaliacao-icon-simple span-class="text--primary"
                                             :avaliacao="pontuacao"/>
              <v-icon class="ml-3 mr-1 mb-1">mdi-calculator</v-icon>
              <px-fornecedor-score :score="score"/>
            </v-skeleton-loader>
          </div>
          <v-row dense v-if="detalhes.nome && !isPessoaFisica">
            <v-col cols="12">
              <v-icon>mdi-account-tie</v-icon>
              <px-span-tooltip bottom
                               tooltip="Nome receita"
                               :text="fornecedor.pessoa.nome"/>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12">
              <v-icon>mdi-domain</v-icon>
              <px-fornecedor-documento span-class="px-0 pl-1" :fornecedor="fornecedor"/>
              <px-regime-tributario :regime-tributario="fornecedor.pessoa.regimeTributario"/>
            </v-col>
          </v-row>
          <v-divider/>
          <v-row dense>
            <v-col cols="12">
              <div class="font-weight-medium">
                <v-icon>mdi-bell</v-icon>
                <px-span-tooltip
                  bottom
                  tooltip="Esses contatos receberão alertas automáticos de cotações e pedidos de
                  compra."
                  text="Contatos para notificações"/>
              </div>
            </v-col>
          </v-row>
          <v-row dense v-if="!this.isCadastrado">
            <v-col cols="12">
              <div>
                <v-icon color="info">mdi-information</v-icon>
                <px-span-tooltip
                  bottom
                  tooltip="Algumas informações podem estar limitadas."
                  text="Este fornecedor não pertence à sua rede."/>
              </div>
            </v-col>
          </v-row>
          <v-row dense v-else-if="this.hasContatos">
            <v-col cols="12" sm="12" v-if="detalhes && detalhes.emails && detalhes.emails.length">
              <template v-for="(email, index) in detalhes.emails">
                <div :key="index">
                  <v-icon color="green">
                    mdi-email
                  </v-icon>
                  {{ email }}
                </div>
              </template>
            </v-col>
            <v-col cols="12" sm="12" v-else>
              <v-icon color="red">
                mdi-email
              </v-icon>
              Não há e-mail cadastrado
            </v-col>
            <v-col cols="12" sm="12"
                   v-if="whatsapps
                    && whatsapps.length">
              <template v-for="(whatsapp, index) in whatsapps">
                <div :key="index">
                  <v-icon color="green">
                    mdi-whatsapp
                  </v-icon>
                  {{ formatContato(whatsapp) }}
                </div>
              </template>
            </v-col>
            <v-col v-else>
              <v-icon color="red">
                mdi-whatsapp
              </v-icon>
              Nenhuma Whatsapp cadastrado
            </v-col>
          </v-row>
          <v-row dense v-else>
            <v-col cols="12">
              <v-icon color="warning">
                mdi-alert
              </v-icon>
              <px-span-tooltip
                bottom
                tooltip="Este fornecedor não receberá notificações de cotações ou compras."
                text="Nenhum canal de notificação cadastrado."/>
            </v-col>
          </v-row>
          <v-divider/>
          <v-row dense v-if="fornecedor.site">
            <v-col cols="12">
              <v-icon>mdi-web</v-icon>
              {{ fornecedor.site }}
              <v-btn icon :href="site" target="_blank">
                <v-icon small>
                  mdi-open-in-new
                </v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12">
              <v-icon>mdi-map-marker</v-icon>
              {{ endereco(fornecedor) }}
            </v-col>
          </v-row>
          <v-row dense v-if="!isPessoaFisica">
            <v-col cols="12">
              <span class="caption font-weight-bold">CNAE principal</span>
              <span v-if="fornecedor.atividadePrincipal">
                {{ fornecedor.atividadePrincipal.codigoCnae }} -
                {{ fornecedor.atividadePrincipal.descricao }}
              </span>
              <span v-else>
                Não informado
              </span>
            </v-col>
          </v-row>
        </template>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
import Vue from 'vue';
import { TipoFornecedor } from 'px-business-components';
import { computeEndereco } from '@/utils/endereco-utils';
import FornecedorService from '@/api/fornecedor-service';

export default {
  props: {
    icon: {
      type: String,
      default: 'mdi-chevron-down',
    },
    showScore: {
      type: Boolean,
      default: false,
    },
    fornecedorId: Number,
  },
  data: () => ({
    menuOpened: false,
    loading: false,
    loadingDetalhes: false,
    score: null,
    detalhes: null,
  }),
  computed: {
    site() {
      if (!this.fornecedor.site) {
        return null;
      }
      if (this.fornecedor.site.includes('http://') || this.fornecedor.site.includes('https://')) {
        return this.fornecedor.site;
      }
      return `https://${this.fornecedor.site}`;
    },
    pontuacao() {
      if (!this.score) {
        return null;
      }
      return this.score.pontuacaoMedia;
    },
    fornecedor() {
      return this.detalhes ? this.detalhes.fornecedor : null;
    },
    linkFornecedor() {
      if (this.detalhes && this.detalhes.id) {
        return `/fornecedor/${this.detalhes.id}`;
      }
      return 'fornecedores/cadastro';
    },
    endereco() {
      return fornecedor => computeEndereco(fornecedor.endereco);
    },
    formatPhone() {
      return phone => (this.isNacional() ? Vue.filter('phone')(phone) : phone);
    },
    isPessoaFisica() {
      return this.fornecedor.tipoFilho === TipoFornecedor.keys.PESSOA_FISICA.key;
    },
    whatsapps() {
      if (!this.detalhes) {
        return [];
      }
      return this.detalhes.contatosWhatsapp.filter(c => c.ativo && c.whatsappValido);
    },
    formatContato() {
      return contato => (contato.nome ? `${this.formatPhone(contato.telefone)} - ${contato.nome}`
        : `${this.formatPhone(contato.telefone)}`);
    },
    isCadastrado() {
      return this.detalhes && this.detalhes.id;
    },
    hasContatos() {
      return this.whatsapps.length || (this.detalhes.emails && this.detalhes.emails.length);
    },
  },
  methods: {
    getScore() {
      this.loading = true;
      FornecedorService.getFornecedorScore(this.fornecedorId)
        .then(({ data }) => {
          this.score = data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getDetalhes() {
      this.loadingDetalhes = true;
      FornecedorService.getFornecedorDetalhes(this.fornecedorId)
        .then(({ data }) => {
          this.detalhes = data;
        })
        .finally(() => {
          this.loadingDetalhes = false;
        });
    },
    isNacional() {
      return this.fornecedor.tipo === TipoFornecedor.keys.NACIONAL.key;
    },
  },
  watch: {
    menuOpened(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      if (this.menuOpened && this.showScore && !this.score) {
        this.getScore();
      }
      if (this.menuOpened && !this.detalhes) {
        this.getDetalhes();
      }
    },
  },
};
</script>
